export default {
  data() {
    return {
      dialogVisible: false,
      list: []
    };
  },
  methods: {
    init(arr) {
      this.list = arr;
      this.dialogVisible = true;
    }
  }
};